import React, { ReactNode, useState } from 'react';
import { Button, ButtonGroup, Stack } from '@mui/material';

interface Props {
  onSelectedTab?: (key: string) => void;
  configuration: { key: string; label: string; disabled?: boolean }[];
  renderNestedSectionByMode: Record<Props['configuration'][number]['key'], ReactNode>;
}

export const BtnsTabsContainer = ({ configuration, renderNestedSectionByMode, onSelectedTab }: Props) => {
  const [structureRenderMode, setStructureRenderMode] = useState<string>(configuration[0].key);

  return (
    <Stack gap="0.5rem">
      <ButtonGroup fullWidth>
        {configuration.map(({ key, label, disabled = false }) => (
          <Button
            key={key}
            color="primary"
            disabled={disabled}
            variant={structureRenderMode !== key ? 'outlined' : 'contained'}
            onClick={() => {
              if (typeof onSelectedTab === 'function') onSelectedTab(key);
              setStructureRenderMode(key);
            }}
          >
            {label}
          </Button>
        ))}
      </ButtonGroup>

      {renderNestedSectionByMode[structureRenderMode]}
    </Stack>
  );
};
